import {Component, OnInit} from '@angular/core';

import {QuestionnaireService} from '../service/questionnaire.service';
import {MessageService} from '../service/message.service';
import {QuestionnaireListItem} from "../model/questionnaire-list-item";

@Component({
  selector: 'app-questionnaires',
  templateUrl: './questionnaires.component.html',
  styleUrls: ['./questionnaires.component.css']
})
export class QuestionnairesComponent implements OnInit {

  drafts: QuestionnaireListItem[];
  versions: QuestionnaireListItem[];
  questionnaire: QuestionnaireListItem;

  constructor(private messageService: MessageService,
              private questionnaireService: QuestionnaireService) { }

  ngOnInit() {
    this.questionnaire = new QuestionnaireListItem(null, '', '', '', false);
    this.loadDrafts();
    this.loadVersions();
  }

  loadDrafts(): void {
    this.questionnaireService.getDrafts()
      .subscribe(v => this.drafts = v, err =>
         this.messageService.addDefaultError(err)
       );
  }

  loadVersions(): void {
    this.questionnaireService.getVersions()
      .subscribe(v => this.versions = v, err =>
         this.messageService.addDefaultError(err)
      );
  }

  onSubmit(): void {
    if (this.questionnaire.id) {
      this.questionnaireService.updateQuestionnaire(this.questionnaire)
        .subscribe(v => {
          this.questionnaire.time = v.time;
          this.questionnaire = new QuestionnaireListItem(null, '', '', '', false);
          }, err =>
          this.messageService.addDefaultError(err)
        );
    } else {
      this.questionnaireService.addQuestionnaire(this.questionnaire.title, this.questionnaire.description)
        .subscribe(v => {
          let newDraft: QuestionnaireListItem = new QuestionnaireListItem(v.id, this.questionnaire.title, this.questionnaire.description, v.time, false);
          this.drafts.push(newDraft);
          this.questionnaire.title = '';
          this.questionnaire.description = '';
          },
          err =>
            this.messageService.addDefaultError(err)
        );
    }
  }

  onSelect(questionnaire: QuestionnaireListItem): void {
    this.questionnaire = questionnaire;
  }

  onCommit(questionnaire: QuestionnaireListItem): void {
     if (confirm('Do you want to publish this draft? It will be available for clients.')) {
       this.questionnaireService.commitQuestionnaire(questionnaire)
         .subscribe(v => {
           let idx: number = this.drafts.indexOf(questionnaire);
           this.drafts.splice(idx, 1);
           this.versions.splice(0, 0, new QuestionnaireListItem(v.id, questionnaire.title, questionnaire.description, v.time, false));
         });
     }
  }

  onRemove(questionnaire: QuestionnaireListItem): void {
    if (confirm('Are you sure you want to discard this draft?')) {
      this.questionnaireService.deleteQuestionnaire(questionnaire)
        .subscribe(v => {
           let idx: number = this.drafts.indexOf(questionnaire);
           this.drafts.splice(idx, 1);
      }, err => this.messageService.addDefaultError(err)
      );
    }
  }

  onDeleteVersion(version: QuestionnaireListItem): void {
    if (confirm('Are you sure you want to delete the published version?')) {
       this.questionnaireService.deleteVersion(version)
       .subscribe(v => {
            let idx: number = this.versions.indexOf(version);
            this.versions.splice(idx, 1);
            }, err => this.messageService.addDefaultError(err)
       );
    }
  }

  onDraftFromVersion(version: QuestionnaireListItem): void {
    if (confirm('Do you want to create a draft from this version? The original version remains unchanged.')) {
      this.questionnaireService.draftFromVersion(version)
        .subscribe(v => {
          let newDraft: QuestionnaireListItem = new QuestionnaireListItem(v.id, version.title, version.description, v.time, false);
          this.drafts.push(newDraft);
        }, err => this.messageService.addDefaultError(err)
        );
    }
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/questionnaires/questionnaires.component.ts